import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, effect, inject, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { I18NextAdapterPipe, I18nService } from '@pflegix/i18n';
import {
  AppIcon,
  AppIconService,
  ConfirmationDialogService,
  EntityHeaderComponent,
  SidebarWithConfirmationComponent,
} from '@pflegix/ui';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { OverviewViewComponent } from '../../../../../view/root/children/orders/children/overview/overview-view.component';
import { OrderHeaderDataComponent } from '../../../order-header-data';
import { OrderStore } from '../../../store';
import { ORDER_DETAILS_SIDEBAR_NAMESPACE } from './i18n/order-details-sidebar-namespace.const';
import { ORDER_DETAILS_SIDEBAR_TRANSLATION_DE } from './i18n/order-details-sidebar.translation.de';
import { ORDER_DETAILS_SIDEBAR_TRANSLATION_EN } from './i18n/order-details-sidebar.translation.en';

@Component({
  selector: 'pfx-order-details-sidebar',
  imports: [
    SidebarWithConfirmationComponent,
    OrderHeaderDataComponent,
    OverviewViewComponent,
    EntityHeaderComponent,
    RouterLink,
    I18NextAdapterPipe,
  ],
  providers: [ConfirmationDialogService, ConfirmationService],
  templateUrl: './order-details-sidebar.component.html',
})
export class OrderDetailsSidebarComponent
  extends SidebarWithConfirmationComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private readonly i18n = inject(I18nService);
  private readonly appIconService = inject(AppIconService);

  public orderId = input.required<string>();

  @ViewChild(OverviewViewComponent) protected overviewViewComponent!: OverviewViewComponent;

  protected icon = signal<AppIcon>({ icon: faInfoCircle });

  protected i18nNamespace = ORDER_DETAILS_SIDEBAR_NAMESPACE;

  private subscription = new Subscription();

  private orderStore = inject(OrderStore);

  constructor() {
    super();

    this.i18n.addTranslations({
      namespace: ORDER_DETAILS_SIDEBAR_NAMESPACE,
      de: ORDER_DETAILS_SIDEBAR_TRANSLATION_DE,
      en: ORDER_DETAILS_SIDEBAR_TRANSLATION_EN,
    });

    effect(() => {
      const orderId = this.orderId();

      this.orderStore.loadOrder$(orderId);
    });
  }

  public ngOnInit(): void {
    this.setIcon();
  }

  public override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.subscription.add(
      this.overviewViewComponent.confirmSubject.subscribe((hasConfirmed) => {
        if (hasConfirmed) {
          this.overviewViewComponent.resetUpdateForm();
        }
      })
    );
  }

  public override ngOnDestroy(): void {
    this.subscription.unsubscribe();
    super.ngOnDestroy();
  }

  private setIcon(): void {
    const appIcon = this.appIconService.getOrderIcon();

    if (!appIcon) {
      return;
    }

    this.icon.set(appIcon);
  }
}
